import React, { useState, useEffect } from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/xml/xml';
import { html as beautifyHtml } from 'js-beautify';

const isSensitive = (id) => id === 'RESET_PASSWORD' || id === 'EMAIL_VERIFICATION';
const isClubNotificationEmail = (id) => id === 'USER_VERIFIED' || id === 'MEMBER_APPLICATION';

const EmailTemplateEditModal = ({ isOpen, onClose, emailTemplate, onSave }) => {
  const [subject, setSubject] = useState('');
  const [htmlBody, setHtmlBody] = useState('');
  const [ccAddresses, setCcAddresses] = useState('');
  const [bccAddresses, setBccAddresses] = useState('');

  useEffect(() => {
    if (emailTemplate) {
      setSubject(emailTemplate.subject || '');
      setHtmlBody(beautifyHtml(emailTemplate.htmlBody || '', { indent_size: 2 }));
      setCcAddresses(emailTemplate.ccAddresses || '');
      setBccAddresses(emailTemplate.bccAddresses || '');
    }
  }, [emailTemplate]);

  const handleSave = () => {
    const formattedHtml = beautifyHtml(htmlBody, { indent_size: 2 });
    onSave({ 
      ...emailTemplate, 
      subject, 
      htmlBody: formattedHtml, 
      textBody: formattedHtml,
      ccAddresses,
      bccAddresses
    });
  };

  if (!isOpen || !emailTemplate) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto">
        <h3 className="text-lg font-semibold mb-4">{emailTemplate.id}</h3>
        <div className="mb-4">
          <label className="block font-medium text-sm mb-1">Subject</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className="mt-1 block w-full px-3 py-2 bg-white border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          />
        </div>
        {isClubNotificationEmail(emailTemplate.id) && (
          <div className="mb-4">
            <label className="block font-medium text-sm mb-1">To: (separate with semicolons)</label>
            <input
              type="text"
              value={ccAddresses}
              onChange={(e) => setCcAddresses(e.target.value)}
              className="mt-1 block w-full px-3 py-2 bg-white border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
        )}
        {!isSensitive(emailTemplate.id) && !isClubNotificationEmail(emailTemplate.id) && (
          <>
            <div className="mb-4">
              <label className="block font-medium text-sm mb-1">Cc: (separate with semicolons)</label>
              <input
                type="text"
                value={ccAddresses}
                onChange={(e) => setCcAddresses(e.target.value)}
                className="mt-1 block w-full px-3 py-2 bg-white border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
            <div className="mb-4">
              <label className="block font-medium text-sm mb-1">Bcc: (separate with semicolons)</label>
              <input
                type="text"
                value={bccAddresses}
                onChange={(e) => setBccAddresses(e.target.value)}
                className="mt-1 block w-full px-3 py-2 bg-white border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </>
        )}
        <div className="mb-4">
          <label className="block font-medium text-sm mb-1">HTML Body</label>
          <CodeMirror
            value={htmlBody}
            options={{
              mode: 'xml',
              theme: 'default',
              lineNumbers: true,
            }}
            onBeforeChange={(editor, data, value) => {
              setHtmlBody(value);
            }}
            style={{ minHeight: '400px' }}
          />
        </div>
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-slate-600 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailTemplateEditModal; 